export const CAMPAIGN_GAME_INIT = 'timewreck/campaignGame/GAME_INIT';
